export const GA_EVENT_FAVORITES = 'favorites';
export const GA_EVENT_FAVORITE_SHARING = 'favorite_sharing';
export const GA_EVENT_FILTER = 'filter';
